import React from 'react';
import { Link } from 'react-router-dom';
import styles from '../TripTrackingV2.module.scss';

const TripHeader = ({ trip }) => (
  <div className={styles.header}>
    <Link to={`/trip/${trip.tripId}`} className={styles.tripNo}>
      {`Trip - ${trip.doNo}`}
    </Link>
    <div className={styles.badgeRow}>
      {trip.isAutoCreated && <span className={styles.badge}>Auto Created</span>}
      {trip.status && (
        <span className={`${styles.badge} ${styles.statusBadge}`} style={{ background: trip.status.code }}>
          {trip.status.text}
        </span>
      )}
      {[trip.serviceType, trip.boundType, trip.runType, trip.modeType].filter(Boolean).map((label) => (
        <span className={styles.badge} key={label}>{label}</span>
      ))}
    </div>
  </div>
);

export default TripHeader;
